@if ((isFreePlan$ | ngrxPush) && !(freePlanNotificationDismissed$ | ngrxPush)) {
  <div class="main-banner">
    <terra-icon icon="clock"></terra-icon>
    <div class="center-text">Your free trial of {{ PlanName.Thrive }} is over and you are now on the Free plan</div>
    <div class="learn-more" (click)="learnMore()">Learn more</div>
    <terra-icon icon="x" class="close-button" (click)="close()"></terra-icon>
  </div>
}
